module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAABMBAMAAABnmnFTAAAAIVBMVEUAAAAApeEApOEApOEAoeAApOEAp+AAouIAouAApOIAo+GT0QW/AAAAC3RSTlMAMy0IDigXEyMbH4cekLYAAADeSURBVDjLXdO72YJAEEbh7794jXQX8RKtgcbYAXaAHWgH2AF2gB1op/ogMuyZbN7gRDPSPJqCUAKc9BfBmuAJBaEEOEn/UZPgCRUh78CaGvUgJXgDa2rYbwKcDKypicGM8CDkDUy7fSHAkhA+MLYmIWsBTQ2sCQiEmpC18Ns1AUtCINRf+Pk2ASsBEkIgnDs4tE3ASoCEEAjW1LEBATaEhFAQyh5cm9MBbAi+DxdrGpQRoKn7+20InlBF8HyfI8AJkMZwm3tCBUBTJydASpgRHoBtDtgJsycEQk3IsL8A2o07bvr1O7UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankMin/sanjiao2.png
// module id = yEeN
// module chunks = 69